export const addSingleMarkers = ({
    locations,
    map,
    t,
    handleModalProps,
    setAppState,
    navigate
  }: {
    locations: any;
    map: google.maps.Map | undefined | any;
    t: Function;
    handleModalProps: any;
    setAppState: any;
    navigate: any;
  }) => {
    // const defaultIconImage = "https://d14giuafm9ljvl.cloudfront.net/uploads/630b05eb-cbee-44b6-9197-3a8fb10a8142/original/icon-pgenerico.png"
    let bounds = new google.maps.LatLngBounds();
    return locations.map(
      (position: any) => {
        let myLatLng = new google.maps.LatLng(position?.lat, position?.lng);
        const marker = new google.maps.Marker({
          position,
          map,
          // icon: {
          //   url: defaultIconImage,
          //   scaledSize: new google.maps.Size(40, 50),
          // },
        })

        if (locations?.length > 1) {
          bounds.extend(myLatLng);
          map.fitBounds(bounds);
        }

        const contentString =           
          `<h3 id="firstHeadingMap" class="">${position?.name} </h3>` +
          '<div id="bodyContentMap">' +
          `<p>${t("PointsOfAttention.codeLabel")}: ${position?.code}</p>` +
          `<p>${t("PointsOfAttention.typeLabel")}: ${position?.pointServiceType}</p>` +
          "</div>" +
          '<div id="bodyContentMap">' +
          `<p>${t("PointsOfAttention.countryLabel")}: ${position?.country}</p>` +
          `<p>${t("PointsOfAttention.cityLabel")}: ${position?.city}</p>` +
          "</div>" +
          '<div id="bodyContentMap">' +
          `<p>${t("PointsOfAttention.latitudeLabel")}: ${position?.lat}</p>` +
          `<p>${t("PointsOfAttention.longitudeLabel")}: ${position?.lng}</p>` +
          "</div>" +
          `<button class="myBtn" id="deleteBtn" onclick="functionMap()"> ${t("PointsOfAttention.deleteBtnLabel")} </button>` +
          `<button class="myBtn" id="modifyBtn" onclick="functionMapModify()"> ${t("PointsOfAttention.modifyBtnLabel")} </button>`;
          // `<button class="myBtn" id="copyBtn" onclick="functionMapCopy()"> ${t("PointsOfAttention.copyBtnLabel")} </button>`;
        
        const infowindow: any = new google.maps.InfoWindow({
          content: contentString,
          maxWidth: 350,
          pixelOffset: new google.maps.Size(0, -30),
          disableAutoPan: true,
        });
        
        const functionMap = () => {
          handleModalProps(position)
        }
        const functionMapModify = () => {
          setAppState((prev: any) => ({
            ...prev,
            selectedPointsObject: position,
          }));
          navigate("/pointsofattention/editpointofattention");
        }
        const functionMapCopy = async () => {}

        window.functionMap = functionMap;
        const deleteBtn = document.querySelector("#deleteBtn");
        deleteBtn?.addEventListener("click", functionMap);
        
        window.functionMapModify = functionMapModify;
        const modifyBtn = document.querySelector("#modifyBtn");
        modifyBtn?.addEventListener("click", functionMapModify);
        
        window.functionMapCopy = functionMapCopy;
        const copyBtn = document.querySelector("#copyBtn");
        copyBtn?.addEventListener("click", functionMapCopy);

        marker.addListener("click", () => {
          infowindow.open({
            anchor: marker,
            map,
            shouldFocus: true,
          });
        });

        return marker
      })
    }